export default __webpack_public_path__ + "static/my_view_logo-0ac63335a99344b04fc598c3d9985d5f.svg";